import { getUrlParams } from '../shared'
import { getCleanSearchCookie, parseStashedValues } from './utils'

export const SEARCH_DROPDOWNS = [
  'basic_assignment',
  'time_model',
  'workplace',
  'language_iso'
]

export const SEARCH_CHECKBOXES = ['intranet_only', 'archived', 'publish_ba', 'errors']

export const getValuesFromCaches = () => {
  const searchValues = getUrlParams()

  if (Object.keys(searchValues).length) {
    return parseStashedValues(searchValues)
  }

  return getValuesFromCookie()
}

export const getValuesFromCookie = (cookieName = 'career_search_params') => {
  const cleanValues = getCleanSearchCookie(cookieName)
  if (cleanValues) {
    return parseStashedValues(cleanValues)
  }

  return false
}
